import { createAction } from 'redux-act'

export const fetchClubJoinBannerStart = createAction('hub - fetch club join banner start')

export const fetchClubJoinBannerSuccess = createAction<any>('hub - fetch club join banner success')

export const fetchClubJoinBannerFail = createAction('hub - fetch club join banner fail')

export const setJoinClubModalVisibility = createAction<boolean>(
  'hub - set join club modal visibility',
)

export default {
  fetchClubJoinBannerStart,
  fetchClubJoinBannerSuccess,
  fetchClubJoinBannerFail,
}
